import http from "./httpService";

const apiEndpoint = "/promotions";

export function getEligiblePromotions(customerId, serviceId, originalPrice = 0) {
  return http.get(`${apiEndpoint}/eligible/${customerId}/${serviceId}`, {
    params: { originalPrice }
  });
}

export default {
  getEligiblePromotions
};
